import React from "react";
import {ResponsiveView} from "../../components/index.jsx";
import {Devices} from "../../components/ResponsiveView/consts.js";
import {TableDateSearchProvider} from "../../admin/Context/TableDateSearchContext.jsx";
import {ProviderBriefs} from "./ProviderBriefs.jsx";

export const ProviderBriefsWrapper = () => {
    return (
        <TableDateSearchProvider localStorageKey="providerBriefsSearchDate">
            <ResponsiveView devices={[Devices.desktop, Devices.mobile]}>
                <ProviderBriefs />
            </ResponsiveView>
        </TableDateSearchProvider>
    );
};
